var _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 217,
    viewBox: "0 0 74 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 95.5H64C68.1421 95.5 71.5 98.8579 71.5 103V207C71.5 211.142 68.1421 214.5 64 214.5H13C8.85786 214.5 5.5 211.142 5.5 207V103C5.5 98.8579 8.85786 95.5 13 95.5Z",
    stroke: "#D6AF66",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 155,
    r: 10.5,
    transform: "rotate(-180 38 155)",
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "#D6AF66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9139 30.6163V42.1542L59 50V23L49.9139 30.6163ZM20.0204 23H42.9804C46.3242 23 49.8889 25.7068 49.8889 29.3068V47.7478C49.895 48.3366 49.6648 48.9039 49.2486 49.3255C48.8324 49.7472 48.2641 49.9889 47.6681 49.9978H24.0407C20.2436 49.9978 18 46.6227 18 43.2477L18.0228 25.2478C17.9796 24.9635 17.9996 24.6733 18.0815 24.3974C18.1633 24.1216 18.3049 23.8666 18.4966 23.6503C18.6855 23.4363 18.9208 23.2671 19.185 23.1553C19.4492 23.0436 19.7355 22.992 20.0227 23.0045L20.0204 23Z",
    stroke: "#960018",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup42);
export default __webpack_public_path__ + "static/media/Group 42.d8c179db5324afdd61c3ceb7d31af2d2.svg";
export { ForwardRef as ReactComponent };